module.exports = __webpack_public_path__ + "components/Game/Steps/Intruder/IntruderQuestionImage-4.59c60e44d0edca7d50e86d358d7d2719.jpg";